<template>
  <div id="exhpredictionList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
			<el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="9" class="searchInline">
              <label class="el-form-item__label searchLabel">企业名称</label>
              <el-input size="small" v-model="searchForm.qymc" placeholder="企业名称" clearable></el-input>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="9" class="searchInline">
              <label class="el-form-item__label searchLabel">审批状态</label>
              <el-select size="small" v-model="searchForm.shzt" placeholder="全部" class="searchSelect" clearable>
                <el-option v-for="item in spOption" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">&nbsp;</el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
			<div class="table_container">
        <el-table class="tableStyle" border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" 
          :height="tableheight" tooltip-effect="dark" :row-style="rowStyle">
          <!-- <el-table-column type="selection" width="35"></el-table-column> -->
          <el-table-column type="index" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
          <el-table-column prop="zwgsmc" label="企业名称" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="tyshxydm" label="统一社会信用代码" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="lxrsj" label="原手机号" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="newsj" label="新手机号" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="shzt" label="审核状态" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <span>{{scope.row.shzt | setSHZT(that)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shrmc" label="审核人" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="shsj" label="审核时间" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="shyj" label="审核意见" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column label="操作" width="75" align="center" v-if="hasPermission('blacklist/index:edit')">
            <template slot-scope="scope">
              <el-button v-if="scope.row.shzt == '01'" type="text" @click="toSH(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator v-if="tableData.length>0"></paginator>
        </el-row>
			</div>


      <!-- 审批 -->
      <el-dialog title="审核" :visible.sync="open" :close-on-click-modal="false">
        <el-form :model="form" label-width="130px" :rules="rules" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="审核状态" prop="shzt">
                <el-radio-group v-model="form.shzt" size="small">
                  <el-radio label="03">审核通过</el-radio>
                  <el-radio label="02">审核不通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="shyj" label="审核意见" :rules="form.shzt == '02' ? rules.shyj : []">
                <el-input type="textarea" :autosize="{minRows:3}" maxlength="200" size="small" v-model="form.shyj" placeholder="备注" clearable></el-input>
              </el-form-item>
              <el-row style="margin-top: -15px;margin-bottom: 15px;text-align:right">
                <div class="el-upload__tip">最大可输入<font style="color:red">{{ 200 }}</font>个字，还可输入
                  <span style="color: red" id="cgmsLength">{{200-(form.shyj != null ? form.shyj.length : 0) >= 0 ? 200-(form.shyj != null ? form.shyj.length : 0) : 0}}</span>个字
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="buttonSubmit">
          <el-button type="clear" icon="el-icon-close" size="small" @click="closeDialog">取消</el-button>
          <el-button type="success" icon="el-icon-check" size="small" @click="save">保存</el-button>
        </el-row>
      </el-dialog>
		</div>
  </div>
</template>
<script>
//引入翻页 paginator
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data() {
    return {
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser,
      //搜索表单
      searchForm: {
        qymc: "",
        shzt: ""
      },
      that: this,
      tableData: [],
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      //多选值
      multipleSelection: [],
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      //总记录数
      total: 0,
      form: {
        zwgsmc: "",
        tyshxydm: "",
        newsj: "",
        shzt: "03",
        shyj: ""
      },
      rules: {
        shyj: [
          { required: true, message: "请输入审核意见", trigger: "blur" },
          {
            max: 200,
            message: "审核意见最多为200字",
            trigger: "blur"
          }
        ],
      },
      spOption:[],
      open: false,
    };
  },
  created () {
    if(this.$store.state.listPagePars.has(this.$route.path)){
        this.searchForm = this.$store.state.listPagePars.get(this.$route.path);
        this.currentPage = this.searchForm.pageNum;
        this.pageSize = this.searchForm.pageSize;
      }
    this.selectSpOption()
    this.searchClick('page');
  },
  filters: {
    setSHZT (val, that) {
      if (!val || that.spOption.length <= 0) return "";
      return that.spOption.filter(item => {return item.codeValue == val}).length > 0 ? that.spOption.filter(item => {return item.codeValue == val})[0].codeName : "";
    },
  },
  methods: {
    selectSpOption () {
      this.$axios.get('/codelist/getCodetype/SHZT').then((res) => {
        this.spOption = res.data.result.filter(item => {return item.codeValue == "01" || item.codeValue == "02" || item.codeValue == "03"});
      })
    },
    //表格查询事件
    searchClick (type) {
      let vm = this;
      this.tableData = [];
      if (type != 'page') {
        this.currentPage = 1;
      }
      vm.loading = true;//表格重新加载
      var params = {
        zwgsmc_like: vm.searchForm.qymc.replace(/%/g, "\\%"),
        shzt: vm.searchForm.shzt,
        pageSize: vm.pageSize,
        pageNum: vm.currentPage
      }
      vm.$axios.post('/qybg/page', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage-1)*vm.pageSize);
        vm.tableData = tableTemp.concat(res.data.result.list);
        this.total = res.data.result.total;
        this.exportForm = [this.searchForm.gsmc, this.searchForm.sjzt, this.searchForm.shzt];
        this.loading = false;

        this.$store.dispatch('saveListPagePars', {path: this.$route.path, pars: params});
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    //清空查询条件
    clearClick () {
      this.searchForm.qymc = '';
      this.searchForm.shzt = '';
      this.searchClick('reset');
    },

    //表格勾选事件
    selectionChange (val) {
      this.multipleSelection = val;
    },
    toSH (row) {
      this.form.shzt = "03"
      this.form.shyj = ""
      this.form.uuid = row.uuid
      this.form.zwgsmc = row.zwgsmc
      this.form.tyshxydm = row.tyshxydm
      this.form.newsj = row.newsj
      this.open = true;
    },
    //关闭Dialog
    closeDialog () {
      this.$refs["form"].resetFields();
      this.open = false;
    },
    // 保存
    save () {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          this.form.xgrid = this.currentUser.userid;
          this.form.xgrmc = this.currentUser.username;
          this.form.shrid = this.currentUser.userid;
          this.form.shrmc = this.currentUser.username;
          this.$axios.put("/qybg/updataQyBgByVO", this.form).then(res => {
            if (res.data.code == "00000000") {
              this.$message.success("保存成功")
              this.open = false
              this.searchClick("add")
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            this.$message.error("保存失败")
          })
        }
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/Approval/Approval.vue